/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dispatch_Category_LabelInputs */

const en_dispatch_category_label = /** @type {(inputs: Dispatch_Category_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Category`)
};

const fr_dispatch_category_label = /** @type {(inputs: Dispatch_Category_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catégorie`)
};

const ms_sg2_dispatch_category_label = /** @type {(inputs: Dispatch_Category_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategori`)
};

/**
* | output |
* | --- |
* | "Category" |
*
* @param {Dispatch_Category_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const dispatch_category_label = /** @type {((inputs?: Dispatch_Category_LabelInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dispatch_Category_LabelInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dispatch_category_label(inputs)
	if (locale === "fr") return fr_dispatch_category_label(inputs)
	return ms_sg2_dispatch_category_label(inputs)
});